// extracted by mini-css-extract-plugin
export default {"root":"pzNtmK7ED4wCXIbCYR5y","brands":"py7x8aozSX0YHRHPQpCy","overlapTableContainer":"WMr4Gh3Y9Udmz5YrVvEe","tabulateButton":"cMEkqSOlxLEIgSVy6GMc"};